import Grid from '@mui/material/Grid';
import React, { useState, useEffect } from 'react';
import {
  ButtonWrapper,
  CancelButton,
  SaveButton,
} from '../Episode/Episode.Styled';
import FormTextField from '../common/Forms/FormTextField';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { useSelector, useDispatch } from 'react-redux';
import { PARTICIPANT_URL } from '../../constants';
import {
  getParticipantCommentFormSlice,
  setParticipantComment,
} from '../../redux/participant/ParticipantComment/ParticipantCommentSlice';
import { ParticipantCommentGrid } from '../ui/styled';
import { setNewStopApi, setStopApi } from '../../services/StopApi/StopApi';
import FormSuccess from '../common/Forms/FormSuccess';

const ParticipantComment = () => {
  //const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);
  const [user, setUser] = useState(null);
  const participantId = useSelector(
    (state) => state?.participants?.participantsDetail[0]?.id
  );
  const participantFormData = useSelector((state) => state?.participantComment);
  const defaultValue = {
    participantComment: participantFormData?.value,
  };
  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    //resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, register, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.participantComment]);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && participantId) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken, participantId]);

  const fetchData = async () => {
    const url = `${PARTICIPANT_URL}/${participantId}/comment`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getParticipantCommentFormSlice({ url, authorization }));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };


  const onSubmit = () => {
    const url = `${PARTICIPANT_URL}/${participantId}/comment`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const payload = {
      comment: participantFormData?.value,
    };
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        setFormSuccess(true);
      }
    }).catch((e) => alert(e));
  };
  return (
    <>
      <ParticipantCommentGrid container>
        <FormTextField
          name='participantComment'
          control={control}
          type='text'
          multiline={true}
          rows={3}
          label='Participant Comment'
          register={register('participantComment', {
            onChange: (e) => dispatch(setParticipantComment(e.target.value)),
          })}
        />
        <ButtonWrapper>
          <SaveButton variant='contained' onClick={handleSubmit(onSubmit)}>
            Save
          </SaveButton>
        </ButtonWrapper>
      </ParticipantCommentGrid>
      <FormSuccess formSuccess={formSuccess} setFormSuccess={setFormSuccess} />
    </>
  );
};

export default ParticipantComment;
